import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import InviteTile from './InviteTile';

const InviteList = props => {
  const { t } = useTranslation()
  const { schedules, errors} = props;
  return (
    
    <div className='import__list-wrapper'>
      {/* <p className='paragraph--darkGray paragraph--small'>{`${t('willBeInvitedLabel')}:`}</p> */}
      <div className={errors ? 'import__list import__list--errors' : 'import__list'}>
        {schedules.map (schl => (
          <InviteTile errors={schl.errors} data={schl}  key={schl.newId}/>
      ))}
      </div>
    </div>
  );
};

InviteList.propTypes = {
  schedules: PropTypes.array,
  resetTab: PropTypes.func,
  errors: PropTypes.bool
};

InviteList.defaultProps = {
  schedules: [],
  //resetTab: () => {},
  errors: false
}

export default InviteList;